// extracted by mini-css-extract-plugin
export default {"sliderImage":"SwiperWithRealPhotos_sliderImage__OFI66","GoodsMainSlider":"SwiperWithRealPhotos_GoodsMainSlider__vOF3w","imageContainer":"SwiperWithRealPhotos_imageContainer__6tbXg"};